"use strict";
// only used within the payment iframe component
var PaymentCardResponse = (function () {
    function PaymentCardResponse() {
    }
    return PaymentCardResponse;
}());
exports.PaymentCardResponse = PaymentCardResponse;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/payments/payment-card-response.model.js